var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 29.3908C11.8958 29.3908 11.599 29.2709 11.3596 29.0312C11.1199 28.7918 11 28.4948 11 28.1404C11 27.7862 11.1199 27.4894 11.3596 27.25C11.599 27.0108 11.8958 26.8912 12.25 26.8912H28.0833C28.4375 26.8912 28.7343 27.0109 28.9738 27.2504C29.2135 27.4901 29.3333 27.7872 29.3333 28.1416C29.3333 28.4958 29.2135 28.7926 28.9738 29.032C28.7343 29.2712 28.4375 29.3908 28.0833 29.3908H12.25ZM12.25 21.25C11.8958 21.25 11.599 21.1301 11.3596 20.8904C11.1199 20.6507 11 20.3537 11 19.9995C11 19.6451 11.1199 19.3483 11.3596 19.1091C11.599 18.8697 11.8958 18.75 12.25 18.75H28.0833C28.4375 18.75 28.7343 18.8698 28.9738 19.1095C29.2135 19.3493 29.3333 19.6462 29.3333 20.0004C29.3333 20.3548 29.2135 20.6516 28.9738 20.8908C28.7343 21.1302 28.4375 21.25 28.0833 21.25H12.25ZM2.25 13.1087C1.89583 13.1087 1.59903 12.989 1.35958 12.7495C1.11986 12.5098 1 12.2127 1 11.8583C1 11.5041 1.11986 11.2073 1.35958 10.9679C1.59903 10.7287 1.89583 10.6091 2.25 10.6091H28.0833C28.4375 10.6091 28.7343 10.729 28.9738 10.9687C29.2135 11.2082 29.3333 11.5051 29.3333 11.8595C29.3333 12.2137 29.2135 12.5105 28.9738 12.75C28.7343 12.9891 28.4375 13.1087 28.0833 13.1087H2.25Z",
    fill: "#0B193E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burger-menu-icon.579b59130f7913ea0b915f124ef3f79e.svg";
export { ForwardRef as ReactComponent };